import styled from "styled-components";
import {
  UnorderedList,
  zIndex,
  spacing,
  typography,
  lightColors,
  TextParagraph,
  media,
} from "@ops-gsic/cxp-component-library-react";
import Link from "next/link";

export const HeaderBar = styled.div`
  position: relative;
  z-index: ${zIndex.aboveLow};

  @media ${media.small} {
    [id*="app-header-menu-popup"] {
      min-width: 20%;
    }
  }
`;

export const NotificationButton = styled.button`
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  padding: ${spacing.spacing3};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border-radius: ${spacing.spacing1};

  &:hover {
    opacity: 0.8;
  }

  &:focus,
  &:active {
    box-shadow: 0 0 0 4px ${lightColors.focusOutline};
    outline: 4px solid transparent;
    transition: box-shadow 0.1s ease-in-out;
  }

  &:active {
    background-color: ${lightColors.transparent};
  }
`;

export const NotificationBadge = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  background-color: #c41e3a;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
`;

export const NotificationContent = styled(UnorderedList)`
  margin: ${spacing.spacing0};
  padding: ${spacing.spacing3} ${spacing.spacing0};
  background: ${lightColors.white};
  border-radius: ${spacing.spacing1};
  box-shadow: 3px 4px 4px rgba(0, 0, 0, 0.25);
  list-style: none;
  & li:last-child {
    border-bottom: 1px solid ${lightColors.border};
  }
`;
export const NotificationHeader = styled.div`
  padding: ${spacing.spacing4} ${spacing.spacing4} ${spacing.spacing3};
  // border-bottom: 1px solid ${lightColors.borderLight};
`;

export const NotificationPopover = styled.div`
  position: absolute;
  top: 80%;
  right: ${spacing.spacing4};
  width: 320px;
  background: ${lightColors.white};
  border: 1px solid ${lightColors.border};
  border-radius: ${spacing.spacing1};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: ${zIndex.aboveLow};
`;

// export const NotificationContainer = styled.div`
//   position: relative;
//   display: inline-flex;
//   align-items: center;
// `;

export const StyledMessageLink = styled(Link)`
  text-decoration: none;
  color: ${lightColors.textPrimary};
  display: block;

  &:hover,
  &:visited {
    color: ${lightColors.textPrimary};
  }
`;

export const NotificationItem = styled.li<{ isRead?: boolean }>`
  border-top: 1px solid ${lightColors.border};
  padding: ${spacing.spacing4} calc(${spacing.spacing5} - 3px);
  gap: ${spacing.spacing7};
  max-width: 352px;

  &.view-inbox-item {
    a {
      display: block;
      padding: ${spacing.spacing4} 21px;
    }
  }

  &:hover {
    cursor: pointer;
    background: ${lightColors.backgroundSecondary};
  }

  &::marker {
    color: ${lightColors.focusOutline};
    content: ${(p) => (p.isRead ? "none" : "unset")};
  }
`;
export const NotificationItemContent = styled.div`
  display: flex;
  gap: ${spacing.spacing3};
  padding-left: ${spacing.spacing2};
  padding-top: ${spacing.spacing2};
`;
export const NotificationUnread = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NotificationTitle = styled(TextParagraph)<{ isRead: boolean }>`
    font-size: calc(${typography.fontSizeLarge}px - 1px);
    display: inline;
    margin: ${spacing.spacing0};
    font-weight: ${p =>
        p.isRead ? `${typography.fontWeightRegular}` : `${typography.fontWeightBold}`};
`;

export const NotificationText = styled.div`
  flex: 1;
`;

export const NotificationMessage = styled(TextParagraph)`
  font-size: ${typography.defaultFontSize}px;
  margin: ${spacing.spacing0};

  text-overflow: ellipsis;
  overflow: hidden;
  width: 254px;
  white-space: nowrap;
`;

export const NotificationDate = styled.span`
  font-size: 12px;
  color: ${lightColors.textSecondary};
`;

export const CustomMenuButtonStyled = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing.spacing3};
  background: transparent;
  border: none;
  color: ${lightColors.white};
  padding: ${spacing.spacing2} ${spacing.spacing3};
  cursor: pointer;
  font-weight: ${typography.fontWeightSemiBold};
  font-family: ${typography.fontPrimary};
  font-size: ${typography.defaultFontSize}px;
  transition: background-color 0.2s ease;
  margin: 0;
  white-space: nowrap;

  &:hover {
    background-color: ${lightColors.subHeaderButtonHoverBG};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 4px ${lightColors.focusOutline};
  }

  svg {
    width: 24px;
    height: 24px;
    fill: currentColor;
  }
`;
